package navigation.settings.areas.allareas

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.area.ui.allareas.AllAreasEvent
import com.essntl.features.area.ui.allareas.AllAreasState
import com.essntl.features.area.ui.allareas.AllAreasViewModel

class AllAreasScreenModel(
    areaRepository: AreaRepository,
    loadingManager: LoadingManager,
) : StateScreenModel<AllAreasState>(AllAreasState()) {

    private val viewModel =
        AllAreasViewModel(
            areaRepository = areaRepository,
            state = mutableState,
            scope = screenModelScope,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AllAreasEvent) = viewModel.onEvent(event)
}